import { get, camelCase, capitalize } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import EventModelClass from '@/common/model/EventModelClass'

export default class MultiSectionModel {
  #bgColor
  #bgImage
  #cellType
  #forceRefresh
  #icon
  #note
  #title
  #eventList
  #contentEvent = null
  #viewMoreEvent = null
  #count

  constructor (sectionItem) {
    if (sectionItem) {
      this.#bgColor = get(sectionItem, 'bg_color', '')
      this.#bgImage = get(sectionItem, 'bg_image', '')
      this.#cellType = capitalize(camelCase(get(sectionItem, 'cell_type', '')))
      this.#forceRefresh = get(sectionItem, 'force_refresh', 'n') === 'y'
      this.#icon = get(sectionItem, 'icon', '')
      this.#note = get(sectionItem, 'note', '')
      this.#title = get(sectionItem, 'title', '')
      this.#eventList = get(sectionItem, 'eventlist', [])
      const { onClickEvent, onDisplayEvent, onContentEvent, onViewMoreEvent } = getEventListByType(this.#eventList)
      this.#contentEvent = onContentEvent !== null ? new EventModelClass(onContentEvent) : null
      this.#viewMoreEvent = onViewMoreEvent !== null ? new EventModelClass(onViewMoreEvent) : null
      this.#count = get(sectionItem, 'count', undefined)
    }
  }

  get bandType () {
    return this.#cellType
  }

  get contentEvent () {
    return this.#contentEvent
  }

  get viewMoreEvent () {
    return this.#viewMoreEvent
  }

  get hasViewMore () {
    return this.#viewMoreEvent !== null
  }

  get cellType () {
    return this.#cellType
  }

  get bgColor () {
    return this.#bgColor
  }

  get bgImage () {
    return this.#bgImage
  }

  get title () {
    return this.#title
  }

  get count () {
    return this.#count
  }
}
